var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 6.5C1.75 3.87665 3.87665 1.75 6.5 1.75H17.5C20.1234 1.75 22.25 3.87665 22.25 6.5V17.5C22.25 20.1234 20.1234 22.25 17.5 22.25H6.5C3.87665 22.25 1.75 20.1234 1.75 17.5V6.5ZM9.25 20.75H17.5C19.2949 20.75 20.75 19.2949 20.75 17.5V6.5C20.75 4.70507 19.2949 3.25 17.5 3.25H9.25V20.75ZM7.75 3.25V20.75H6.5C4.70507 20.75 3.25 19.2949 3.25 17.5V6.5C3.25 4.70507 4.70507 3.25 6.5 3.25H7.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebar);
export default __webpack_public_path__ + "static/media/sidebar.3bac09e0bbb7f393d7827f27138a347b.svg";
export { ForwardRef as ReactComponent };